var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/logo/MomentiveLogo.tsx",
  _this = this;
import React from 'react';
export var MomentiveLogo = function MomentiveLogo(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": label,
    viewBox: "0 0 36 24",
    "data-testid": "MomentiveLogoMark",
    width: 36,
    height: 24,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "MomentiveLogoMarkGroup1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "MomentiveLogoMarkGroup2",
    transform: "translate(-0.000000, 0.000000)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.137,11.242 C21.576,14.893 23,19.28 23,24 L36,24 L36,0 L19.137,11.242",
    id: "MomentiveLogoMarkFill11",
    fill: "#2CB2F1",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1 L0,24 L19.137,11.242 C15.0125,5.068 7.9825,1 0,1",
    id: "MomentiveLogoMarkFill12",
    fill: "#FFE11B",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,24 L23,24 C23,19.28 21.576,14.893 19.137,11.242 L0,24",
    id: "MomentiveLogoMarkFill13",
    fill: "#008323",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  }))));
};
//# sourceMappingURL=MomentiveLogo.js.map